import Image from 'next/image'
import type { FunctionComponent } from 'react'
import { cn } from '@dreamstack/util/src/cn'

const avatarBaseClass =
  'transform bg-accentroWhite-200 mr-px-4 rounded-full flex justify-center items-center relative overflow-hidden md:ml-px-12'
const avatarSizeClass = (
  opts: { big?: boolean; extraSmall?: boolean }
) =>
  cn(
    opts.big ? 'scale-150' : 'scale-100',
    opts.extraSmall
      ? 'h-px-40 w-px-40 md:m-0 md:h-px-32 md:w-px-32 lg:h-px-48 lg:w-px-48'
      : 'h-px-48 w-px-48'
  )

const headBaseClass = 'bg-yellow-100 rounded-full'
const headSizeClass = (extraSmall?: boolean) =>
  extraSmall
    ? 'h-px-16 w-px-16 md:h-px-8 md:w-px-8 lg:h-px-16 lg:w-px-16'
    : 'h-px-16 w-px-16'

const bodyBaseClass = 'absolute bg-gray-300 bottom-0 rounded-full'
const bodySizeClass = (extraSmall?: boolean) =>
  extraSmall
    ? '-mb-px-16 h-px-32 w-px-32 md:h-px-16 md:w-px-16 md:-mb-px-4 lg:-mb-px-16 lg:h-px-32 lg:w-px-32'
    : '-mb-px-16 h-px-32 w-px-32'

export const BrokerAvatar: FunctionComponent<
  React.PropsWithChildren<{
    url?: string | null
    big?: boolean
    extraSmall?: boolean
  }>
> = ({ url, big, extraSmall }) => {
  return (
    <div>
      <div className={cn(avatarBaseClass, avatarSizeClass({ big, extraSmall }))}>
        <div className={cn(headBaseClass, headSizeClass(extraSmall))} />
        <div className={cn(bodyBaseClass, bodySizeClass(extraSmall))} />
        {url && (
          <Image
            className="absolute object-cover"
            fill
            src={url}
            alt={'broker avatar image'}
          />
        )}
      </div>
    </div>
  )
}
